import { apiDlUrl } from '@/environment/environment';

export const apiConstants = {
  fetchGuide: 'mock-data/sandbox/guide.json',
  fetchTags: 'mock-data/tags.json',
  fetchArtefacts: 'mock-data/sandbox/artefacts.json',
  fetchArtefact: 'mock-data/sandbox/artefact.json',
  fetchArtifactUnit: 'mock-data/sandbox/artefactUnit.json',
  bdi: apiDlUrl+'appdevindex',
  bfdi: apiDlUrl+'appdevindex',
  cdi: apiDlUrl+'appdevindex',
  bdl: apiDlUrl+'apphierinfo',
  cdl: apiDlUrl+'apphierinfo',
  phi: apiDlUrl+'cliperfhist',
  
  sso_mock: 'mock-data/sandbox/sso.json',

  // bdi: apiDlUrl+'clidevindex',
  // bfdi: apiDlUrl+'clidevindex',
  // cdi: apiDlUrl+'clidevindex',
  // bdl: apiDlUrl+'clihierinfonew',
  // cdl: apiDlUrl+'clihierinfonew',
  // phi: apiDlUrl+'cliperfhist',

//  bdi: 'mock-data/sandbox/clidevindex.json',
//  bfdi: 'mock-data/sandbox/clidevindex.json',
//  cdi: 'mock-data/sandbox/clidevindex.json',
//  bdl: 'mock-data/sandbox/clihierinfonew.json',
//  cdl: 'mock-data/sandbox/clihierinfonew.json',
//  phi: 'mock-data/sandbox/cliperfhist.json'
};
